export default __webpack_public_path__ + "static/spiritual-maya-activity-5-6b9d2f56dd70053722c7706f2fa1b760.jpg";